<template>
  <div class="w-full min-h-screen">
    <router-view></router-view>
    <Analytics />
  </div>
</template>

<script setup>
import { watch, onMounted } from 'vue'
import { Analytics } from '@vercel/analytics/vue'
import { useStructuredData } from './composables/useStructuredData'

const { injectStructuredData } = useStructuredData()

// Inject structured data on mount and route changes
onMounted(() => {
  injectStructuredData()
})

watch(() => window.location.pathname, () => {
  // Small delay to ensure route is fully loaded
  setTimeout(() => {
    injectStructuredData()
  }, 100)
})
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

body {
  @apply m-0 p-0;
}

#app {
  @apply w-full min-h-screen;
}
</style>